module.exports = __webpack_public_path__ + "static/media/Portfolio.0cff58dc.jpg";